import { TravelRatePeriodDto } from '../context/GlobalContext'

// The Dutch untaxed kilometre allowance; the final fallback when neither the file nor the
// organisation-wide TRAVEL_RATE setting yields a rate for the travel date.
export const DEFAULT_TRAVEL_RATE = '0.23'

const formatRate = (rate: number | string): string => {
    const parsed = typeof rate === 'number' ? rate : Number(rate)
    return isNaN(parsed) ? undefined : parsed.toFixed(2)
}

// Periods should not overlap; when they do anyway, the first matching period wins (HAM-3627).
const periodContains = (period: TravelRatePeriodDto, isoDate: string): boolean =>
    (!period.validFrom || period.validFrom <= isoDate) && (!period.validTo || isoDate <= period.validTo)

/**
 * Resolve the kilometre rate to prefill for a travel registration: the file override when set,
 * otherwise the organisation-wide period containing the travel date, otherwise € 0,23.
 */
export function resolveTravelRate(fileTravelRate: string | undefined, periods: TravelRatePeriodDto[] | undefined, isoDate: string): string {
    if (fileTravelRate) {
        return formatRate(fileTravelRate) ?? DEFAULT_TRAVEL_RATE
    }

    const period = isoDate ? (periods || []).find(period => periodContains(period, isoDate)) : undefined
    return (period && formatRate(period.rate)) ?? DEFAULT_TRAVEL_RATE
}
